<template>
  <v-container fluid class="pt-0 mt-0">
    <v-row>
      <v-spacer />

      <v-col cols="12" md="11">
        <v-card class="mx-auto" :loading="searchLoading">
          <v-toolbar color="teal" dark>
            <v-toolbar-title style="color: white" v-if="apiData && apiData.length > 0">
              <span
                v-if="!searchResults && !screeenIsTooSmallBoardName"
                v-html="apiData[0].boardTitle"
              ></span>
            </v-toolbar-title>

            <v-btn v-if="searchResults" outlined class="ma-1" @click="clearSearch()">{{
              backToTopicsLabel
            }}</v-btn>

            <v-spacer></v-spacer>

            <v-text-field
              hide-details
              v-model="searchText"
              :label="searchLabel"
              class="ma-0 pa-0"
              v-on:keyup.enter="submitSearch"
            >
            </v-text-field>

            <v-btn @click="submitSearch" icon :loading="searchLoading">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>

            <v-btn
              v-if="apiData && apiData.length > 0 && userIsLoggedIn"
              class="ma-2"
              outlined
              :loading="markAllAsReadProcessing"
              @click="markAllAsRead"
            >
              {{ markTopicsAsReadLabel }}
              <i
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-checkbox-marked theme--light"
                style="font-size: 16px"
              ></i>
            </v-btn>

            <v-btn
              v-if="apiData && apiData.length > 0 && userIsLoggedIn"
              class="ma-2"
              outlined
              :to="
                '/forumpost/new/' + $route.params.board_id + '/' + apiData[0].boardTitle
              "
            >
              {{ addNewTopicLabel }}
              <i
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-email-newsletter theme--light"
                style="font-size: 16px"
              ></i>
            </v-btn>
          </v-toolbar>

          <v-list-item-content class="mx-4 hidden-sm-and-down black-text">
            On the European Palm Society discussion forums you can discuss topics related
            to Palms and other exotic plants, swap and make non-commercial plant sales,
            get in touch with members in your area or places that you might be visiting or
            join us at meets and garden visits. You can also upload photos to ask for
            identification, advice, or just share a great picture with others.
          </v-list-item-content>

          <div v-if="!searchResults">
            <v-pagination
              v-model="pageIndex"
              :length="totalPages"
              :total-visible="15"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              circle
              @input="getAPIData()"
            ></v-pagination>

            <v-skeleton-loader
              class="mx-auto mb-6"
              type="article@2"
              v-if="apiData == null"
            ></v-skeleton-loader>

            <v-list two-line subheader>
              <v-list-item
                v-for="topic in apiData"
                :key="topic.id"
                :to="'/post/' + $route.params.board_id + '/' + topic.id"
                class="topicrow"
              >
                <v-list-item-avatar
                  rounded
                  size="80"
                  left
                  v-if="topic.authorAvatar"
                  class="d-sm-block d-none"
                >
                  <v-img :src="getAvatarPath(topic.authorAvatar)"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title style="font-weight: bold" class="text-wrap">
                    {{ getTopicSubjectText(topic) }}

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          v-if="topic.topicClosed"
                          class="ma-0 pa-0"
                          color="warning"
                        >
                          <i
                            aria-hidden="true"
                            class="ma-0 pa-0 v-icon notranslate mdi mdi-key theme--light"
                            style="font-size: 16px"
                          ></i>
                        </v-btn>
                      </template>
                      <span>Thread locked for new posts</span>
                    </v-tooltip>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap black-text"
                    ><b>Original Post:</b>
                    {{ formatDateTime(topic.startDate, topic.startTime) }} by
                    {{ topic.authorForename + " " + topic.authorSurname }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap black-text"
                    ><b>Last Post:</b>
                    {{ formatDateTime(topic.lastEntryDate, topic.lastEntryTime) }}
                    by {{ topic.lastPostForename + " " + topic.lastPostSurname }}
                  </v-list-item-subtitle>
                  <v-list-item-content class="mt-0 mb-0 pt-0 pb-0">
                    <v-row class="mt-0 mb-0 pt-0 pb-0">
                      <v-col cols="12" class="mt-0 mb-0 pt-0 pb-0">
                        {{ topic.views }} Views
                        <v-chip
                          small
                          :color="getRepliesColour('bg', topic)"
                          :text-color="getRepliesColour('fg', topic)"
                        >
                          {{ getRepliesMessage(topic) }}</v-chip
                        >
                        <!-- <v-list-item-action> -->
                        <v-btn
                          style="font-size: 12px"
                          small
                          v-if="topic.owner || userIsModerator()"
                          class="ma-2 red"
                          outlined
                          v-on:click.prevent
                          @click="showDialog(topic)"
                        >
                          {{ deleteText }}
                          <i
                            aria-hidden="true"
                            class="v-icon notranslate mdi mdi-delete theme--light"
                            style="font-size: 12px"
                          ></i>
                        </v-btn>
                        <!-- </v-list-item-action> -->
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-pagination
              v-model="pageIndex"
              :length="totalPages"
              :total-visible="11"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              circle
              @input="getAPIData()"
            ></v-pagination>
          </div>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
    <div v-if="searchResults">
      <v-spacer />
      <v-col cols="12" md="11">
        <h2>Search Results</h2>
        <v-pagination
          v-model="pageIndex"
          :length="totalPages"
          :total-visible="11"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          circle
          @input="performSearch()"
        ></v-pagination>

        <v-card v-if="searchResults.length == 0" class="ma-3" outlined>
          <v-list-item-title class="pa-2 ma-2">
            <h4>
              No results were found matching '<em>{{ searchText }}</em
              >'
            </h4>
          </v-list-item-title>
        </v-card>

        <v-card v-for="hit in searchResults" :key="hit.postId" class="ma-3" outlined>
          <v-list>
            <v-list-item>
              <v-list-item-avatar tile size="80" color="grey">
                <v-img :src="getFullAvatarUrl(hit.postUserAvatar)"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="ma-2" tag="h1">
                  <router-link :to="getPostLink(hit)"
                    >In Topic: {{ hit.subject }} on
                    {{ formatDateTime(hit.messageDateSerial, hit.messageTimeSerial) }}
                    {{ hit.postForename }}
                    {{ hit.postSurname }} posted</router-link
                  >
                </v-list-item-title>
                <v-card-text
                  v-html="atMax3Paragraphs(formatPostTextForDisplay(hit))"
                ></v-card-text>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-spacer />
    </div>
    <div class="text-center">
      <v-dialog v-if="this.selectedTopic" v-model="dialogVisible" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> Confirm Delete </v-card-title>

          <v-card-subtitle class="ma-4 pa-4">
            Please confirm you want to delete the topic "{{ this.selectedTopic.subject }}"
            and all associated posts. <br />
            <br />
            This action cannot be undone
          </v-card-subtitle>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text @click="dialogCancelled()"> Cancel </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogConfirmed()">
              Confirm Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import userFunctions from "@/functions/userFunctions";
import serverFunctions from "@/functions/serverFunctions";
import dateFunctions from "@/functions/dateFunctions";
import dataStore from "../functions/dataStore";
import stringFunctions from "@/functions/stringFunctions";
import forumFunctions from "@/functions/forumFunctions";

export default {
  data: () => ({
    apiData: null,
    totalPages: 0,
    pageIndex: parseInt(dataStore.getPagingValue("topics")),
    pageSize: 25,
    dialogVisible: false,
    searchLoading: false,
    selectedTopic: null,
    searchText: null,
    searchResults: null,
    markAllAsReadProcessing: false,
    boardTitle: "",
  }),
  metaInfo() {
    const boardTitle = this.boardTitle.replace("&amp;", "&");
    return {
      title: boardTitle,
    };
  },
  computed: {
    userIsLoggedIn() {
      return userFunctions.userIsLoggedIn();
    },
    deleteText() {
      return this.$vuetify.breakpoint.xsOnly ? "" : "Delete";
    },
    screeenIsTooSmallBoardName() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    searchLabel() {
      return this.$vuetify.breakpoint.smAndDown ? "Search..." : "Enter search text...";
    },
    backToTopicsLabel() {
      return this.$vuetify.breakpoint.smAndDown ? "Back" : "Back To Topics";
    },
    addNewTopicLabel() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return "";
      }
      return this.$vuetify.breakpoint.smAndDown ? "New" : "Add New Topic";
    },
    markTopicsAsReadLabel() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return "";
      }
      return this.$vuetify.breakpoint.smAndDown ? "Read" : "Mark All As Read";
    },
    showBreadcrumbs() {
      return !this.$vuetify.breakpoint.smAndDown;
    },
    getPagesAvailable: function () {
      if (this.apiData) {
        let pagesAvailable = Math.floor((this.apiData.length - 1) / this.pageSize) + 1;
        return pagesAvailable;
      } else {
        return 0;
      }
    },
    currentUser: function () {
      return dataStore.getCurrentUser();
    },
  },
  methods: {
    userIsModerator() {
      return userFunctions.currentUserIsModerator();
    },

    getPostLink(post) {
      return "/post/" + post.boardId + "/" + post.topicId + "/" + post.postId;
    },
    atMax3Paragraphs(text) {
      return stringFunctions.atMax3Paragraphs(text);
    },
    getFullAvatarUrl(avatar) {
      return userFunctions.getFullAvatarUrl(avatar);
    },
    formatPostTextForDisplay(post) {
      return forumFunctions.formatPostTextForDisplay(post);
    },
    clearSearch() {
      this.searchResults = null;
      this.searchText = null;
      this.$router.push({
        name: "ForumTopics",
        params: { board_id: this.$route.params.board_id },
      });
      this.pageIndex = 1;
      this.getAPIData();
    },
    submitSearch() {
      this.$router.push({
        name: "ForumTopicsSearch",
        params: { board_id: this.$route.params.board_id, search: this.searchText },
      });
      this.pageIndex = 1;
      this.performSearch();
    },

    async performSearch() {
      dataStore.setPagingValue("topics", this.pageIndex);
      this.searchLoading = true;
      const searchRequest = serverFunctions.getSearchForumBoardRequestObject(
        userFunctions.getLoggedInUser(),
        this.$route.params.board_id,
        this.searchText,
        this.pageSize,
        this.pageIndex
      );
      let searchResponse = (this.searchResults = await serverFunctions.getRawPostResponse(
        "/searchBoard",
        searchRequest
      ));
      if (searchResponse.resultsCount) {
        this.totalPages =
          Math.floor((searchResponse.resultsCount - 1) / this.pageSize) + 1;
      } else {
        this.totalPages = 0;
      }
      this.searchResults = searchResponse.result;

      this.searchLoading = false;
    },
    getAvatarPath(avatar) {
      return userFunctions.getFullAvatarUrl(avatar);
    },
    showDialog(eventDetail) {
      this.selectedTopic = eventDetail;
      this.dialogVisible = true;
    },
    async dialogConfirmed() {
      await this.deleteTopic(this.selectedTopic.id);
      this.dialogVisible = false;
    },
    dialogCancelled() {
      this.dialogVisible = false;
    },
    formatDateTime(date, time) {
      return dateFunctions.formatPalmDateTime(date, time);
    },
    getRepliesColour(elem, topic) {
      if (topic.unreadReplies > 0) {
        return elem === "bg" ? "primary" : "white";
      } else {
        return elem === "bg" ? "alert" : "black";
      }
    },
    getTopicSubjectText(topic) {
      if (topic.topicAnnouncement) {
        return "Announcement: " + topic.subject;
      } else if (topic.topicIsSticky) {
        return "Sticky: " + topic.subject;
      }
      return topic.subject;
    },
    getRepliesMessage(topic) {
      if (topic.unreadReplies == 0) {
        return topic.replies + " replies";
      } else {
        if (topic.unreadReplies >= topic.replies) {
          return topic.unreadReplies + " unread";
        } else {
          return topic.unreadReplies + " / " + topic.replies + " unread";
        }
      }
    },
    async deleteTopic(topicId) {
      const deleteTopicRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        topicId
      );
      await serverFunctions.getPostResponse("/deleteTopic", deleteTopicRequest);
      this.getAPIData();
    },
    async markAllAsRead() {
      let boardId = this.$route.params.board_id;
      const markBoardPostsReadRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        boardId
      );
      this.markAllAsReadProcessing = true;
      await serverFunctions.getPostResponse("/markAllAsRead", markBoardPostsReadRequest);
      this.getAPIData();
      this.markAllAsReadProcessing = false;
      userFunctions.updateUnreadMessageCount();
    },
    async getAPIData() {
      dataStore.setPagingValue("topics", this.pageIndex);

      var boardId = this.$route.params.board_id;

      if (boardId == "topic.asp") {
        let topicId = this.$route.query.topicid;
        this.$router.push({
          name: "ForumPostViewTopic",
          params: { board_id: 0, topic_id: topicId },
        });
      }

      if (boardId == "board.asp") {
        boardId = this.$route.query.boardid;
        this.$router.push({ name: "ForumTopics", params: { board_id: boardId } });
      }

      const topicsRequest = serverFunctions.getPagedDataRequestObject(
        userFunctions.getLoggedInUser(),
        boardId,
        this.pageSize,
        this.pageIndex - 1 //Get is zero bound
      );
      this.apiData = await serverFunctions.getPostResponse("/getTopics", topicsRequest);

      const topicCountRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        boardId
      );

      const totalTopics = await serverFunctions.getPostResponse(
        "/getTopicCountForBoard",
        topicCountRequest
      );

      this.totalPages = Math.floor((totalTopics[0].topicCount - 1) / this.pageSize) + 1;

      window.scrollTo(0, 0);

      this.boardTitle = this.apiData[0].boardTitle;
    },
  },
  beforeMount() {
    if (this.$route.params.search) {
      this.searchText = this.$route.params.search;
      this.performSearch();
      return;
    }
    this.getAPIData();
  },
};
</script>

<style scoped></style>
